import { ApiClient } from "@/api-client/src/core/api-client";
import { CouponResponse } from "@/packages/types/discount";

const apiClient = new ApiClient();
const webService = apiClient.web;

export const fetchCouponByCode = async (
  couponCode: string
): Promise<CouponResponse> => {
  const response = await webService.get<CouponResponse>(
    `/coupon/code/${couponCode}`
  );
  return response;
};
